/* jshint esversion: 6 */
import * as ActionCable from '../vendor/action_cable';

export const AvoCable = ActionCable.createConsumer();
